import CaasStorageKeys from '../../constants/caas.storage.keys';
import NavigationUtils from '../../utils/navigation.utils';
import { EducationalOnboardingType } from './EducationalOnboardingProvider';
import CaasLocalStorageKeys from '../../constants/caas.local.storage.keys';
import Base64Utils from '../../utils/base64.utils';

export class EducationalOnboardingInterceptor {
  static interceptURL(
    type = EducationalOnboardingType,
    destinationPath = '',
    config,
  ) {
    const navigationComponents =
      config[CaasStorageKeys.STORAGE][
        CaasLocalStorageKeys.NAVIGATION_COMPONENTS
      ] ?? [];

    if (!navigationComponents.includes(`eo-${type}`)) {
      const params =
        destinationPath !== ''
          ? { path: Base64Utils.encode(destinationPath) }
          : {};

      NavigationUtils.navigate(
        `${NavigationUtils.Routes.EDUCATIONAL_ONBOARDING}/${type}`,
        true,
        params,
      );

      return true;
    }

    return false;
  }
}
